import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { exportToExcel } from 'react-json-to-excel';
import { Comentarios, Arrow } from '../../../../assets/images';
import { getUser } from '../../../utils/apiUser';
import {
  getUsersThatLikedOrCommented,
  getNewById
} from '../../../utils/apiNews';
import { CommentsModel } from '../../../model';
import Comment from './Comment';
import InfiniteScroller from '../../core/InfiniteScroller';
import {
  StyleButtonArrow,
  StyleButtonsSend,
  StyleForm,
  StyleNumComments,
  StyleTextArea,
  StyleWrapComments,
  StyleWrapCommentsBox,
  StyleWrapTitle,
  StyleWrapTotalComments,
  StyledIcon,
  StyledIconArrowDown,
  StyledIconArrowUp,
  StyledTitle
} from './styleNewsComments';
import ModalDraw from './ModalDraw';
import { showReplies, hideReplies } from './helpers';
import { Confirmation } from '../Employee/Edition';
import { DELETE_COMMENT } from '../../../constants/literals/modals';
import { A3MIL_USER_ID } from '../../../constants/content';
import ModalError from '../../core/ModalError';

class NewsComments extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rolesUser: [],
      currentUserId: null,
      showModalDraw: false,
      commentToDelete: null,
      deleteError: false
    };

    this.loadReplies = this.loadReplies.bind(this);
  }

  componentDidMount() {
    const {
      location: { hash }
    } = this.props;
    const height = this.totalComments.offsetTop - 70;

    if (hash === '#comments') {
      setTimeout(() => {
        window.scrollTo(0, height);
      }, 300);
    }
    getUser().then(user => {
      this.setState({
        rolesUser: user.roles,
        // null si no llega, para no coincidir con comentarios sin userId
        currentUserId: user.userId != null ? String(user.userId) : null
      });
    });
  }

  onAcceptDeleteComment = () => {
    const { removeComment, subtractComment, comments } = this.props;
    const { commentToDelete } = this.state;
    // Un comentario principal desaparece de la lista con sus respuestas, asi
    // que el contador baja tambien por ellas; una respuesta solo cuenta 1
    const isMainComment = comments.some(item => item.id === commentToDelete.id);
    const amount = isMainComment ? 1 + (commentToDelete.numReplies || 0) : 1;
    // Los comentarios de A3Mil se borran por su propio endpoint
    const generic = String(commentToDelete.userId) === A3MIL_USER_ID;

    this.setState({ commentToDelete: null });
    removeComment(commentToDelete.replyId || commentToDelete.id, { generic })
      .then(() => subtractComment(amount))
      .catch(() => this.setState({ deleteError: true }));
  };

  loadReplies(id, e) {
    const { loadAllReplies } = this.props;

    loadAllReplies(id);
    showReplies(e);
  }

  // eslint-disable-next-line class-methods-use-this
  downLoadExcel(newID) {
    let newTitle = '';
    getNewById(newID).then(response => {
      newTitle = `${response.title.split(' ')[0]} ${
        response.title.split(' ')[1]
      } ${response.title.split(' ')[2]}`;
    });
    getUsersThatLikedOrCommented(newID).then(response => {
      exportToExcel(response, `Comentarios_y_likes_noticia_${newTitle}`);
    });
  }

  render() {
    const {
      id,
      page,
      comments,
      form,
      updateForm,
      submitForm,
      toggleAnswer,
      answerId,
      answer,
      updateAnswer,
      submitFormGenericComment,
      sendAnswer,
      loadMoreComments,
      numComments
    } = this.props;

    const {
      rolesUser,
      currentUserId,
      showModalDraw,
      commentToDelete,
      deleteError
    } = this.state;
    const canManageComments = rolesUser.includes('ROLE_NEWS_COMMENTS');
    // Cada usuario borra los suyos; con el rol de A3Mil, tambien los de A3Mil
    const canDeleteComment = item => {
      const authorId = String(item.userId);
      return (
        authorId === currentUserId ||
        (canManageComments && authorId === A3MIL_USER_ID)
      );
    };

    const updatedComments = [];
    const updatedIdSet = new Set();

    const clearComments = () => {
      comments.forEach(comment => {
        if (!updatedIdSet.has(comment.id)) {
          updatedIdSet.add(comment.id);
          updatedComments.push(comment);
        }
      });
    };

    return (
      <>
        <StyleWrapTotalComments
          innerRef={data => {
            this.totalComments = data;
          }}
        >
          {showModalDraw && (
            <ModalDraw
              onCloseModal={() => this.setState({ showModalDraw: false })}
              newId={id}
            />
          )}
          <StyleWrapComments>
            <StyleWrapCommentsBox>
              <div>
                <StyleWrapTitle>
                  <StyledIcon size="l" svg={Comentarios} />
                  <StyledTitle>Comentarios</StyledTitle>
                </StyleWrapTitle>
                {rolesUser.includes('ROLE_NEWS_COMMENTS') && (
                  <div>
                    <div>
                      <StyleButtonsSend
                        onClick={() => this.setState({ showModalDraw: true })}
                      >
                        Comenzar Sorteo
                      </StyleButtonsSend>
                    </div>
                    <div>
                      <StyleButtonsSend onClick={() => this.downLoadExcel(id)}>
                        Descargar Excel comentarios
                      </StyleButtonsSend>
                    </div>
                  </div>
                )}
                <StyleForm>
                  <StyleTextArea
                    placeholder="Añadir un comentario..."
                    name="comment"
                    onChange={updateForm}
                    value={form.comment}
                    area
                    rows={2}
                    // error=""
                    multiline
                  />
                  <StyleButtonsSend
                    type="submit"
                    onClick={submitForm}
                    disabled={!form.comment}
                  >
                    Enviar
                  </StyleButtonsSend>

                  {rolesUser.includes('ROLE_NEWS_COMMENTS') && (
                    <div>
                      <div>
                        <StyleButtonsSend
                          type="submit"
                          onClick={submitFormGenericComment}
                          disabled={!form.comment}
                        >
                          Comentar como A3Mil
                        </StyleButtonsSend>
                      </div>
                    </div>
                  )}
                </StyleForm>
              </div>
              <div id="comments">
                <StyleNumComments>{numComments} Comentarios</StyleNumComments>
                <InfiniteScroller
                  page={page}
                  loadMore={() => loadMoreComments(id)}
                >
                  {clearComments()}
                  {updatedComments.map(comment => (
                    <Comment
                      canDelete={canDeleteComment(comment)}
                      onDelete={() =>
                        this.setState({ commentToDelete: comment })
                      }
                      comment={comment}
                      key={comment.id}
                      answer={answer}
                      answerId={answerId}
                      reply
                      toggleAnswer={toggleAnswer}
                      updateAnswer={updateAnswer}
                      sendAnswer={sendAnswer}
                      canAnswerAsA3Mil={canManageComments}
                      userId={String(comment.userId)}
                    >
                      {comment.replies.map(item => (
                        <Comment
                          key={item.replyId || item.id}
                          comment={item}
                          reply={false}
                          secondary
                          className="reply"
                          userId={String(item.userId)}
                          canDelete={canDeleteComment(item)}
                          onDelete={() =>
                            this.setState({ commentToDelete: item })
                          }
                        />
                      ))}

                      <StyleButtonArrow
                        onClick={e => {
                          this.loadReplies(comment.id, e);
                        }}
                        className={
                          comment.numReplies < 2 &&
                          comment.numReplies === comment.replies.length
                            ? `btnShow hide`
                            : `btnShow`
                        }
                      >
                        Ver las {comment.numReplies} respuestas
                        <StyledIconArrowDown svg={Arrow} />
                      </StyleButtonArrow>

                      <StyleButtonArrow
                        onClick={e => hideReplies(e)}
                        className="btnHide hide"
                      >
                        Ocultar respuestas
                        <StyledIconArrowUp svg={Arrow} />
                      </StyleButtonArrow>
                    </Comment>
                  ))}
                </InfiniteScroller>
              </div>
            </StyleWrapCommentsBox>
          </StyleWrapComments>
        </StyleWrapTotalComments>
        {commentToDelete && (
          <Confirmation
            onCloseModal={() => this.setState({ commentToDelete: null })}
            onAcceptModal={this.onAcceptDeleteComment}
            data={DELETE_COMMENT}
          />
        )}
        {deleteError && (
          <ModalError
            error="No se pudo eliminar el comentario. Inténtelo de nuevo."
            onCloseModal={() => this.setState({ deleteError: false })}
          />
        )}
      </>
    );
  }
}

NewsComments.propTypes = {
  id: PropTypes.string,
  page: PropTypes.number,
  comments: PropTypes.arrayOf(CommentsModel),
  form: PropTypes.shape({
    comment: PropTypes.string
  }),
  removeComment: PropTypes.func,
  subtractComment: PropTypes.func,
  updateForm: PropTypes.func,
  submitForm: PropTypes.func,
  toggleAnswer: PropTypes.func,
  submitFormGenericComment: PropTypes.func,
  answerId: PropTypes.string,
  answer: PropTypes.string,
  updateAnswer: PropTypes.func,
  sendAnswer: PropTypes.func,
  loadAllReplies: PropTypes.func,
  loadMoreComments: PropTypes.func,
  numComments: PropTypes.number
};

export default NewsComments;
